import { deepMerge } from '@empathybroker/deep-merge';
import { Module } from 'vuex';
import { DiscoveryWallState } from '../../models';
import { DeepPartial } from '../../utils';
import { RootStoreState } from '../store.interfaces';
import { DISCOVERY_WALL_ACTIONS } from './discovery-wall.actions';
import { DISCOVERY_WALL_GETTERS } from './discovery-wall.getters';
import { DISCOVERY_WALL_MUTATIONS } from './discovery-wall.mutations';
import { getInitialDiscoveryWallState } from './discovery-wall.state';

export function getDiscoveryWallModule(overrideModule?: DeepPartial<Module<DiscoveryWallState, RootStoreState>>):
  Module<DiscoveryWallState, RootStoreState> {
  return deepMerge({
    namespaced: true,
    actions: DISCOVERY_WALL_ACTIONS,
    getters: DISCOVERY_WALL_GETTERS,
    mutations: DISCOVERY_WALL_MUTATIONS,
    state: getInitialDiscoveryWallState()
  }, overrideModule);
}
